import {useMemo} from "react";
import localeNumberSeparators from "#lib/localeNumberSeparators";

export default function useLocaleNumberSeparators() {
  return useMemo(localeNumberSeparators, []);
}